import { Navigate } from "react-router-dom";

function ProtectedRoute({ children }) {
  const user = sessionStorage.getItem("user");

  if (!user) {
    return <Navigate to="/entrar" replace />;
  }

  return children;
}

export default ProtectedRoute;
